export default __webpack_public_path__ + "assets/4cbe1bcfbc505687b2f5b1679a79ba13.png";